import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  let sid = sessionStorage.getItem("_ign_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("_ign_sid", sid);
  }
  return sid;
}

export function usePageTracker() {
  const location = useLocation();
  const startTime = useRef(Date.now());
  const lastPage = useRef("");

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith("/admin")) return;

    const page = location.pathname;
    const sessionId = getSessionId();

    // Send duration for previous page
    if (lastPage.current && lastPage.current !== page) {
      const duration = Math.round((Date.now() - startTime.current) / 1000);
      if (duration > 0) {
        navigator.sendBeacon(
          `${API}/track`,
          JSON.stringify({ page: lastPage.current, session_id: sessionId, duration, referrer: "", screen_width: 0 })
        );
      }
    }

    startTime.current = Date.now();
    lastPage.current = page;

    // Track page view
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page,
        referrer: document.referrer || "",
        screen_width: window.innerWidth,
        session_id: sessionId,
        duration: 0,
      }),
    }).catch(() => {});

    // Send duration on tab close
    const handleUnload = () => {
      const duration = Math.round((Date.now() - startTime.current) / 1000);
      navigator.sendBeacon(
        `${API}/track`,
        JSON.stringify({ page, session_id: sessionId, duration, referrer: "", screen_width: 0 })
      );
    };
    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, [location.pathname]);
}
